<template>
    <div class="">
        <div class="row col-md-12 justify-content-center">
            <h5>{{ labels.title }}</h5> 
        </div>
        <div class="col-md-10 d-flex justify-content-center mt-3 align-items-center">
            <div class="col-md-4 d-flex justify-content-end">
                <h5>{{labels.vigencia}}</h5> 
            </div>
            <div class="col-md-4 d-flex justify-content-start" v-if="listaFechas?.length > 0"> 
                <!-- <input type="month" :items="vigencia" class="form-control"> -->
                <select :items="vigencia" class="form-control">
                    <option value="">{{ labels.seleccion }}</option> 
                    <option v-for="item in listaFechas" :key="item?.id" :value="item?.vigencia"> {{ item?.vigencia }} </option> 
                </select>
            </div>
            <div class="col-md-4 d-flex justify-content-start" v-else>
                <input type="month" :items="vigencia" class="form-control">
            </div>
            <div class="d-flex justify-content-end" v-if="listaFechas?.length > 0"> 
                <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="adicionUltimaPlantcc()">
                    <i class="fa-solid fa-plus"></i>
                </b-button>
            </div>
        </div>
        <div class="col-md-10 d-flex justify-content-center mt-2 align-items-center" v-if="showNewVig">
            <div class="col-md-4 d-flex justify-content-end">
                <h5>{{labels.newVigencia}}</h5> 
            </div>
            <div class="col-md-4 d-flex justify-content-start">
                <input type="month" :items="newVigencia" class="form-control">
            </div>
            <div class="d-flex justify-content-end">
                <b-button style="background-color: #d80027; width: 30px; height: 30px;" class="md-fab md-primary" @click="deleteRowFecha()">
                    <i>delete</i>
                </b-button>
            </div>
        </div>
        <div class="col-md-12 d-flex justify-content-end">
            <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="adicionaCentroCosto()">
                <i class="fa-solid fa-plus"></i>
            </b-button>
        </div>
        <b-row class="justify-content-center">
            <b-col cols="10">
                <b-row class="justify-content-center" v-if="listContratoCentroCostos != 0">
                    <b-table
                        :items="listContratoCentroCostos"
                        :fields="fields"
                        hover
                        bordered
                        responsive
                        
                        small
                        class="tblEstandar"
                        head-variant="custom-blue"
                        
                        
                        @row-clicked="(item) => modificarCentro(item.id)" 
                    >
                        <template #cell(centro_costo_num)="data">
                            <div class="text-right">{{ data.item?.centro_costo }}</div> 
                        </template>
                        <template #cell(centro_costo)="data">
                            <div class="text-left">{{ centroCosto(data.item?.centro_costo) }}</div> 
                        </template>
                    </b-table>
                    <div class="row col-md-12 align-items-center">
                        <div class="col-md-10 d-flex justify-content-center">
                            <b-pagination
                            :items="currentPage"
                            :total-rows="listContratoCentroCostos.length" 
                            
                            align="center"
                            size="md"
                            class="custom-pagination"
                            ></b-pagination>
                        </div>
                        <div class="col-md-2 d-flex justify-content-end">
                            <label class="mr-2 mb-0">Filas por página:</label>
                            <b-form-select
                            :items="perPage"
                            :options="[5, 10, 20, 50, 100, 500]"
                            size="sm"
                            style="width: 80px;"
                            ></b-form-select>
                        </div>
                    </div>
                    <!-- <b-table md-card md-header :items="listContratoCentroCostos">
                        <b-table-row slot="b-table-row" slot-scope="{ item }" @click="modificarCentro(item)">
                            <b-table-cell :md-label="labels.vigencia" class="border text-left">{{ item?.vigencia }}</b-table-cell> 
                            <b-table-cell :md-label="labels.centroCosto" class="border text-left">{{ item?.centro_costo }}</b-table-cell> 
                            <b-table-cell :md-label="labels.centroCostoD" class="border text-left">{{ centroCosto(item?.centro_costo) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.porcentaje" class="border text-right">{{ item?.porcentaje }}</b-table-cell> 
                        </b-table-row>
                    </b-table> -->
                </b-row>
                <b-row class="justify-content-center" v-else>
                    <h5>{{ labels.noRow }}</h5> 
                </b-row>
            </b-col>
        </b-row>
        <b-row v-if="fgl_adicionar">
            <AdicionarCentroCosto :modalAdCentroCostos="showAdCentroCostos" :numContrato="numContrato" :vigencia="vigencia" :newVigencia="newVigencia" @reloadTblCntCst="refrescaTblCntCst" @cierraModal="closeModal"></AdicionarCentroCosto>
        </b-row>
        <b-row>
            <!-- <b-col class="d-flex justify-content-end" cols="10">
                <b-button class="md-primary" @click="saveModActivos">{{ labels.save }}</b-button> 
            </b-col> -->
            <b-col class="d-flex justify-content-end" cols="12">
                <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
            </b-col>
        </b-row>
        <EditarCentroCosto :modEditCentroCostos="showModEditCC" :numContrato="numContrato" :Infocc="detallecc" @reloadTblCntCst="refrescaTblCntCst" @cierraModal="closeModalEdit"></EditarCentroCosto>
    </div>
</template>

<script>
import ContratoCentroCostos from '../../services/ContratoCentroCostos'; 
import AdicionarCentroCosto from './AdicionarCentroCosto.vue'; 
import CentroCostos from '../../services/CentroCostos'; 
import EditarCentroCosto from './EditarCentroCosto.vue'; 

export default {
    name : 'ModificacionCentroCosto',
    props : ['numContrato'],
    components : {
        AdicionarCentroCosto,
        EditarCentroCosto
    },
    data : () => ({
        listCentroCostos : [],
        listContratoCentroCostos : [],
        activos : [],
        lstTipoActivo : [],
        valAddMejora : '',
        valRetiro : '',
        fgl_adicionar: false,
        showAdCentroCostos: false,
        quitaCentroCosto: false,
        codActivo: null,
        vigencia : '',
        perPage: 500,
        currentPage: 1,
        fields: [
            // { key: 'vigencia', label: 'Vigencia', sortable: false },
            { key: 'centro_costo_num', label: 'Centro costo', sortable: false },
            { key: 'centro_costo', label: 'Descripción', sortable: false },
            { key: 'porcentaje', label: 'Porcentaje', sortable: false },
        ],
        showModEditCC : false,
        detallecc : [],
        listaFechas : [],
        showNewVig : false,
        newVigencia : '',
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Centros de Costos',
                    save : 'Guardar',
                    close : 'Cerrar',
                    noRow : "No hay registros",
                    activos : 'Activos',
                    tipoActivo : 'Tipo Activo',
                    proveedor : 'Proveedor',
                    valorCompra : 'Valor Inicial',
                    valorSalvamento : 'Valor salvamento',
                    valorAmortizado : 'Valor amortizado',
                    fechaCompra : 'Fecha compra',
                    valAddMejora : 'Valor adición/mejora',
                    valRetiro : 'Valor retiro',
                    centroCosto: 'Centro Costo',
                    centroCostoD: 'Descripcion',
                    porcentaje: 'Porcentaje',
                    vigencia: 'Vigencia',
                    newVigencia : 'Nueva vigencia',
                    seleccion : 'Seleccione...' 
                }            
            }else{
                return {
                    title : 'Costing',
                    save : 'Save',
                    close : 'Close',
                    noRow : "There are not records",
                    activos : 'Assets',
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    valorCompra : 'Purchase value',
                    valorSalvamento : 'Salvage value',
                    valorAmortizado : 'Amortized value',
                    fechaCompra : 'Purchase date',
                    valAddMejora : 'Added value/Improvement',
                    valRetiro : 'Withdrawal value',
                    centroCosto: 'Centro Costo',
                    centroCostoD: 'Descripcion',
                    porcentaje: 'Porcentaje',
                    vigencia: 'Validity',
                    newVigencia : 'New validity',
                    seleccion : 'Select...' 
                }                
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        saveModActivos(){
            console.log('saveModActivos'); 
        },
        quitarCentro(centroCosto){
            this.centro_costo = centroCosto 
            this.quitaCentroCosto = true 
        },
        cierraModalAdv(){
            this.quitaCentroCosto = false 
        },
        adicionaCentroCosto() {
            this.fgl_adicionar = true 
            this.showAdCentroCostos = true 
        },
        closeModal(val){
            this.showAdCentroCostos = val 
        },
        closeModalEdit(valor){
            this.showModEditCC = valor 
        },
        centroCosto(centroCosto) {
            if	(centroCosto == null || centroCosto == undefined) {
                return ''
            }
            const v_centro = this.listCentroCostos.find((centro) => centro.centro_costo == centroCosto) 
            if	(v_centro == undefined) {
                return "Centro costo "+centroCosto
            }
            return v_centro?.descripcion 
        },
        modificarCentro(cc) {
            // console.log(cc) 
            ContratoCentroCostos.consultaCentroCostoById(cc) 
            .then((res) => { 
                // console.log(res.data); 
                this.detallecc = res.data.infoCentroCosto 
                this.showModEditCC = true 
            })
            .catch((err) => console.log(err)) 
        },
        refrescaTblCntCst(valFecha){
            this.showAdCentroCostos = false 
            this.showModEditCC = false 

            ContratoCentroCostos.leaContratoCentroCostos(this.numContrato) 
            .then((res) => { 
                // console.log(res.data); 
                this.listContratoCentroCostos = res.data.listContratoCentroCostos 
                this.listContratoCentroCostos = this.listContratoCentroCostos.filter((cc) => cc.vigencia == valFecha) 
            })
            .catch((err) => console.log(err)) 
        },
        adicionUltimaPlantcc(){
            this.showNewVig = true 

            const lastFecha = this.listaFechas[0] 
            this.vigencia = lastFecha.vigencia //Asigno ultima fecha para cargar plantilla por el watch 
        },
        deleteRowFecha(){
            this.showNewVig = false 
        },
        recargaTblcc(){
            this.showNewVig = false 
            this.vigencia = this.newVigencia 
        }
    },
    mounted(){
        CentroCostos.getAllCentroCostos() 
        .then((res) => { 
            this.listCentroCostos = res.data.listCentroCostos 
        })
        .catch((err) => console.log(err)) 

        // ContratoCentroCostos.leaContratoCentroCostos(this.numContrato) 
        // .then((res) => { 
        // console.log(res.data); 
        // this.listContratoCentroCostos = res.data.listContratoCentroCostos 
        // })
        // .catch((err) => console.log(err)) 
        ContratoCentroCostos.getFechasCentroCostosByContrato(this.numContrato) 
        .then((res) => { 
            // console.log(res.data); 
            this.listaFechas = res.data.lstFechas 
        })
        .catch((err) => console.log(err)) 


    },
    watch:{
        vigencia(valVigencia){
            // console.log(valVigencia,'VIGENCIA'); 
            const lastFecha = this.listaFechas[0] 

            if(valVigencia == ""){
                this.listContratoCentroCostos = [] 
                this.showNewVig = false 
            
            }else if(valVigencia <= lastFecha.vigencia){ 
                

                ContratoCentroCostos.leaContratoCentroCostos(this.numContrato) 
                .then((res) => { 
                    // console.log(res.data); 
                    this.listContratoCentroCostos = res.data.listContratoCentroCostos 
                    this.listContratoCentroCostos = this.listContratoCentroCostos.filter((cc) => cc.vigencia == valVigencia) 
                    this.showNewVig = false 
                })
                .catch((err) => console.log(err)) 
            }
        },
        newVigencia(valFecha){
            // console.log(valFecha); 
            const lastFecha = this.listaFechas[0] 
            if(valFecha <= lastFecha.vigencia){ 
                this.$toast.error(`La vigencia debe ser mayor a ${ lastFecha.vigencia }`) 
            }else{
                console.log(valFecha,lastFecha.vigencia); 

                const info = {
                    'numContrato' : this.numContrato, 
                    'oldFecha' : lastFecha.vigencia, 
                    'newFecha' : valFecha,
                    'idUser' : this.$store.state.userId 
                }
                // console.log(info); 

                ContratoCentroCostos.newPlantillaContratoCentroCosto(info) 
                .then((res) => { 
                    // console.log(res.data); 
                    this.$toast.success(res.data.message) 
                    this.recargaTblcc() 
                })
                .catch((err) => console.log(err)) 
                
            }
        }
    }
}
</script>
